import styled from 'styled-components';

export const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 400px;
  max-width: 700px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;

  &:focus-visible {
    outline: 2px solid #007bff;
    outline-offset: 2px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;

export const MessageContent = styled.p`
  font-size: 14px;
  color: #333;
  text-align: center;
  margin: 0;
  line-height: 1.5;
`;

export const PairingCodeBox = styled.div`
  margin-top: 16px;
  padding: 16px;
  background-color: #f0f2f5;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 2px;
  text-align: center;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;
